module.exports = __webpack_public_path__ + "img/limit-weight.0ed99d52.png";